<template lang="pug">
  div#cesiumPopupPanelParking
    span.parkingModal__btn-close(@click='close')
      ods-icon.iconClose(name="close" size="20")
    div.containerDataPopup
      template(v-if='datosFinal.length == 0')
        StatusCero(
          title='no data'
          description='no data kpi'
        )
      template(v-else)
        div.containerValuesPopup
          div
            span {{ $t('Calle') }}:
          div.containerTitleDataPopup
            p {{ $t(datosFinal.name) }}
          div.containerValuesPopup
            ods-tag(type="secondary") {{ $t(datosFinal.subtype) }}
          //ods-scrollbar(wrap-class='ods-scrollbar__wrap')
            div.maxSizePopup
              template(v-if="datosFinal")
                div
                  span.tipo {{ $t(datosFinal.name) }}
                  div.valor
                    span.valor {{ datosFinal.selected }}
</template>

<script>
import StatusCero from '@/components/StatusCero'
export default {
  name: 'PopupPanelParking',
  props: {
    datosFinal: {
      // type: Object
    },
    dataCompare: {
      type: Boolean
    },
    dataCompareLoad: {
      type: Boolean
    },
    stationName: {
      type: String
    },
    valorComparado: {
      type: String
    }
  },
  methods: {
    close () {
      this.$emit('closePopUp')
    }
  },
  updated () {
    // console.log('PopupPanelParking datos',this.datosFinal)
  },
  components: {
    StatusCero
  }
}
</script>

<style scoped lang="scss">

#cesiumPopupPanelParking {
  background: $--color-white;
  border-radius: 5px;
  padding-right: rem(24);
  padding: rem(16) rem(32);
  transition: width 0.4s, min-width 0.4s;
  min-width: 259px;
  // z-index: 10;
  z-index: 99;
  position: absolute;
  left: 18px;
  bottom: 70px;
  .cesiumPopup-header {
    height: 20px;
    width: 100%;
    position: relative;
    // background-color: #ffa500;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .cesiumPopup-header-counter {
      color: $--color-neutral-3;
      position: relative;
      padding-left: 5px;
      font-size: 14px;
      .cesiumPopup-header-icons {
        color: $--color-neutral-3;
        float: right;
        font: 20px arial, sans-serif;
        padding-right: 5px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .containerDataPopup {
    .heightMax{
      margin: 0 auto;
      margin-bottom: 20px;
    }
    .containerTitleDataPopup {
      padding-bottom: rem(16);
      margin-bottom: rem(16);
      border-bottom: 1px solid $--color-neutral-3;
      margin-right: rem(8);
      p {
        font-size: rem(16);
        margin-bottom: 4px;
      }
      span {
        text-transform: uppercase;
        background: $--color-primary-light-9;
        padding: 4px;
        display: inline-block;
        border-radius: 5px;
        font-size: 9px;
      }
    }
    .containerValuesPopup{
      min-height: rem(50);
      div {
        margin-bottom: rem(16);
        font-size: rem(10);
        span {
          display: inline-block;
          width: 50%;
          font-weight: bold;
        }
      }
    }
  }
  .maxSizePopup {
    max-height: rem(100);
    padding-right: rem(24);
    text-transform: uppercase;
    div {
      margin-bottom: rem(16);
      font-size: rem(10);
      .tipo {
        font-weight: bold;
        // margin-right: rem(8);
        display: inline-block;
        width: 50%;
      }
      div.valor{
        width: 50%;
        display: inline-block;
        margin-bottom: 0;
        text-align: center;
      }
      span.valor {
        display: inline-block;
        width: auto !important;
        background: $--color-primary-light-9;
        padding: 5px 10px;
        border-radius: 5px;
        color: $--color--grey-medium;
      }
    }
  }
}
.parkingModal{
  &__btn-close{
    display: flex;
    justify-content: right;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PopupPanelParking.vue